export const PROFILE_ACTION = "profile";
export const ADMIN_CONSOLE_ACTION = "admin-console";
export const IP_ASSET_MANAGER_ACTION = "ip-asset-manager";
export const LOGOUT_ACTION = "logout";